<div class="row">
	<div class="form-group col-6 col-md-1">
		<app-gen-select
			[options]="years"
			[actualObj]="this"
			fieldName="year"
			(changeEvent)="runBkmv()"
		/>
	</div>
	<div class="col-6">
		<app-gen-button-group
			[actualObj]="this"
			fieldName="year"
			[options]="periodInputs"
			title_ph_lang="period"
			(changeEvent)="changeByPeriod()"
		/>
	</div>
</div>

<div>
	<app-btn-ext
		text="bkmvdata"
		tabindex="6"
		(clickEv)="runBkmv()"
		[isSpin]="isDownloading"
	/>
</div>
<div id="section-to-print">
	<h4>
		<span>{{ "irs" | langVal }}</span>
	</h4>
	@if (data) {
		<div class="bkmvdata">
			<div style="direction: rtl">
				<p>{{ "osek" | langVal }}: {{ data.vat_number || "" }}</p>
				<p>{{ "name_of_business" | langVal }}: {{ data.name || "" }}</p>
				<p>{{ "ended_successfully" | langVal }}:</p>
				<p>{{ "data_saved_on" | langVal }}: 'C:\Downloads'</p>
				<p>{{ "tax_year" | langVal }}: {{ data.year || "" }}</p>
				<p>{{ "perut_on_bkmvdata" | langVal }}:</p>
			</div>

			<div class="table-responsive">
				<table
					style="width: 60%"
					class="table table-bordered table-striped"
				>
					<tbody>
						<tr>
							<th title="record_code">{{ "record_code" | langVal }}</th>
							<th title="record_description">
								{{ "record_description" | langVal }}
							</th>
							<th title="total_records">{{ "total_records" | langVal }}</th>
						</tr>

						<tr>
							<td>{{ data.a100_record_code || "" }}</td>
							<td>{{ data.a100_record_name || "" }}</td>
							<td>{{ data.a100_total_records || "" }}</td>
						</tr>

						<tr>
							<td>{{ data.b110_record_code || "" }}</td>
							<td>{{ data.b110_record_name || "" }}</td>
							<td>{{ data.b110_total_records || "" }}</td>
						</tr>
						<tr>
							<td>{{ data.c100_record_code || "" }}</td>
							<td>{{ data.c100_record_name || "" }}</td>
							<td>{{ data.c100_total_records || "" }}</td>
						</tr>
						<tr>
							<td>{{ data.d110_record_code || "" }}</td>
							<td>{{ data.d110_record_name || "" }}</td>
							<td>{{ data.d110_total_records || "" }}</td>
						</tr>

						<tr>
							<td>{{ data.d120_record_code || "" }}</td>
							<td>{{ data.d120_record_name || "" }}</td>
							<td>{{ data.d120_total_records || "" }}</td>
						</tr>
						<tr>
							<td>{{ data.z900_record_code || "" }}</td>
							<td>{{ data.z900_record_name || "" }}</td>
							<td>{{ data.z900_total_records || "" }}</td>
						</tr>
					</tbody>
				</table>
				<div style="direction: rtl">
					<p>{{ "perut_tochna_vetaarich" | langVal }}</p>
					<p>
						{{ "hanetunim_hufku" | langVal }}: {{ "My-cliniq" }}
						{{ "teudat_rishum" | langVal }}{{ ":239301" }}
						{{ "betaarich" | langVal }} {{ data.date }}
						{{ "beshaa" | langVal }} {{ data.time }}
					</p>
				</div>

				<table
					style="width: 80%"
					class="table table-bordered table-striped"
				>
					<tbody>
						<tr>
							<th title="document_code">{{ "document_code" | langVal }}</th>
							<th title="document_type">{{ "document_type" | langVal }}</th>
							<th title="quantity">{{ "quantity" | langVal }}</th>
							<th title="total">{{ "total" | langVal }}</th>
						</tr>

						<tr>
							<td>305</td>
							<td>{{ "justinvoice" | langVal }}</td>
							<td>{{ data.document_305_total_records || "" }}</td>
							<td>{{ data.document_305_total_total || "" }}</td>
						</tr>
						<tr>
							<td>320</td>
							<td>{{ "invoice" | langVal }}</td>
							<td>{{ data.document_320_total_records || "" }}</td>
							<td>{{ data.document_320_total_total || "" }}</td>
						</tr>
						<tr>
							<td>400</td>
							<td>{{ "receipt" | langVal }}</td>
							<td>{{ data.document_400_total_records || "" }}</td>
							<td>{{ data.document_400_total_total || "" }}</td>
						</tr>
						<tr>
							<td>330</td>
							<td>{{ "credit" | langVal }}</td>
							<td>{{ data.document_330_total_records || "" }}</td>
							<td>{{ data.document_330_total_total || "" }}</td>
						</tr>
					</tbody>
				</table>
				<div style="direction: rtl">
					<p>{{ "perut_tochna_vetaarich" | langVal }}</p>
					<p>
						{{ "hanetunim_hufku" | langVal }}{{ " My-cliniq" }}
						{{ "teudat_rishum" | langVal }}{{ ": 239301" }}
						{{ "betaarich" | langVal }} {{ data.date || "24-12-2025" }}
						{{ "beshaa" | langVal }} {{ data.time || "19:05" }}
					</p>
				</div>
			</div>
		</div>
	}
</div>

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<button
		tabindex="1"
		class="btn btn-primary"
		(click)="print()"
	>
		{{ "print" | langVal }}
	</button>
</div>
